import classNames from 'classnames'
import React from 'react'
import { Trans, t } from '@lingui/macro'

import { CertificationEnrolmentStatusEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'

import IconSettings from '../../../components/common/icon/IconSettings'
import PageHeader from '../../../components/common/page/header/PageHeader'
import { CertificationEnrolmentCard } from '../components/CertificationEnrolmentCard'
import { linkBuilder, staticLinks } from 'shared/linkBuilder'
import { navigateTo } from '../../../app/util/appHistory'
import { Page } from '../../../components/common/page/Page'
import { useAssignedCertificationsQuery } from '../../home-page/components/your-certifications/YourCertifications.codegen'
import {
  Box,
  ButtonOutline,
  Flex,
  FlexBoxGrid,
  LinkOverlay
} from 'front-end/src/components'
import { AdminOnlyAllowed } from 'front-end/src/components/common/AdminOnlyAllowed'
import CertificationsBadge from 'public/assets/img/certifications-badge.svg'

export const UserCertificationsPage = () => {
  const { data } = useAssignedCertificationsQuery()

  if (!data) {
    return null
  }

  return (
    <Page
      className={classNames('Certifications', {
        'Certifications--empty': !data.me.certificationEnrolments.length,
        'Certifications--list': data.me.certificationEnrolments.length
      })}
    >
      <PageHeader
        title={t`Your certifications`}
        className="PageHeader"
        controls={
          <AdminOnlyAllowed allowManagerAccess>
            <Box display={['none', 'block']}>
              <ButtonOutline
                onClick={() => navigateTo(staticLinks.certificationsManage)}
                leftIcon={<IconSettings />}
              >
                <Trans>Manage certifications</Trans>
              </ButtonOutline>
            </Box>
          </AdminOnlyAllowed>
        }
      />
      {!data.me.certificationEnrolments.length ? (
        <div className="no-items">
          <img src={CertificationsBadge} alt={t`Empty certifications`} />
          <p>
            <Trans>
              Here is a place where you will find all certifications you will be
              awarded.
            </Trans>
          </p>
        </div>
      ) : (
        <Box className="YourCertificationGrid" mr={['8px', 0]} ml={['8px', 0]}>
          <FlexBoxGrid
            columns={['60%']}
            rowGap={'16px'}
            p={'8px'}
            marginOutside
          >
            {[
              CertificationEnrolmentStatusEnum.EXPIRED,
              CertificationEnrolmentStatusEnum.NOT_STARTED,
              CertificationEnrolmentStatusEnum.OVERDUE,
              CertificationEnrolmentStatusEnum.IN_PROGRESS,
              CertificationEnrolmentStatusEnum.COMPLETED
            ].map((statusToRender) => {
              return data.me.certificationEnrolments
                .filter((cert) => cert.status === statusToRender)
                .map((certificationEnrolment) => (
                  <Flex key={certificationEnrolment.id}>
                    <LinkOverlay
                      flexGrow={1}
                      to={linkBuilder.certificationsDetail(
                        certificationEnrolment.certification.id
                      )}
                    >
                      <CertificationEnrolmentCard
                        certificationEnrolment={certificationEnrolment}
                      />
                    </LinkOverlay>
                  </Flex>
                ))
            })}
          </FlexBoxGrid>
        </Box>
      )}
    </Page>
  )
}
